<template>
    <div class="modal modal-lg fade" 
        :id="modalID" 
        :aria-labelledby="theModalLabel" 
        tabindex="-1"
        aria-hidden="true"
        @click.self="close">

	<div class="np-base-dialog modal-dialog modal-dialog-centered">
		<div class="modal-content shadow">
			<div class="modal-header border-0 p-4 pb-2">
				<span class="col-sm-8 d-flex align-middle">
					<svg class="icon"><use href="@/assets/images/icons/folder-add.svg#icon"></use></svg>
					{{ $t("UI.summary.createSpaceOrProject") }}
				</span>
				<div class="d-flex justify-content-end flex-grow-1">
					<button type="button" class="np-btn np-outline" data-bs-dismiss="modal" aria-label="Close">
						<svg><use href="@/assets/images/icons/close3.svg#icon"></use></svg> 
					</button>
				</div>
			</div>

			<div class="modal-body p-4 mt-4 mb-4">
				<div class="row">
					<div class="col">
						<div class="np-panel align-items-center justify-content-center p-4" style="aspect-ratio: 1 / 1;">
							<div class="np-group np-font-m np-f-medium mb-4">
								<svg class="icon"><use href="@/assets/images/icons/folder-open.svg#icon"></use></svg> 
								{{ $t("UI.summary.newSpace") }}
							</div>
							<button type="button" class="np-btn np-btn-info-outline mt-1" @click="doCreateSpace">
								<svg><use href="@/assets/images/icons/plus.svg#icon"></use></svg> 
								{{ $t("UI.summary.createSpace") }}
							</button>
						</div>
					</div>
					<div class="col">
						<div class="np-panel align-items-center justify-content-center np-overflow-visible p-4" style="aspect-ratio: 1 / 1;">
							<div class="np-group np-font-m np-f-medium mb-4">
								<svg class="icon"><use href="@/assets/images/icons/folder.svg#icon"></use></svg> 
								{{ $t("UI.summary.newProject") }}
							</div>

							<multiselect
								v-model="selectedSpace"
								:options="spaces"
								:multiple="false"
								:searchable="false"
								:loading="isLoading"
								selectLabel=""
								:placeholder="this.$t('UI.summary.selectSpace')"
								label="title"
								track-by="id"
								@keydown.enter.native.prevent
							/>

							<button type="button" class="np-btn np-btn-info-outline mt-3" v-if="selectedSpace" @click="doCreateProject">
								<svg><use href="@/assets/images/icons/plus.svg#icon"></use></svg> 
								{{ $t("UI.summary.createProject") }}
							</button>
						</div>						
					</div>					
				</div>
			</div>
		</div>
      </div>
    </div>
</template>
  
<script>
  import { Modal } from "bootstrap"
  import Multiselect from 'vue-multiselect';

  export default {
    components: {
      Multiselect
    },
    props: {
        modalID: {
          type: String,
          required: true
        },        
        modalSize: {
            type: String,
            default: ''
        },
        modalPosition: {
            type: String,
            default: ''
        },
        spaces: {
          type: Array,
          default: []
        }  
    },
    data() {
      return {
        theModal: null,
        theModalLabel: null,   
        error: '',
        isError: false,
        selectedSpace: ''
      }
    },
    mounted: function () {
      var IdModal = '#' + this.$props.modalID
      this.theModalLabel = this.modalID + "Label"
      this.theModal = new Modal(IdModal, {backdrop: true})        
    },     
    computed: {    
    },
    methods: {
      shows() {
		this.selectedSpace = null
        this.theModal.show()
      },
      hide() {
          this.theModal.hide()
      },
      doCreateSpace() {
        this.theModal.hide()
        this.$emit("createSpace", 0, null)
      },
      doCreateProject() {
        this.theModal.hide()
        this.$emit("createProject", this.selectedSpace.id, 0)
      }	  
    }
  }
  </script>
<style>
	.multiselect__single {
		line-height: 23px !important;
	}
</style>